import { MapDrawModeChangeEventData } from './map-draw-mode-changed-event-data';
import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapDrawModeChangeEvent implements MapEvent {
    type = MapEventType.mapDrawModeChanged;
    constructor(public payload: MapDrawModeChangeEventData) {}
}
